






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import StudiesService from '@/shared/services/studies-service';
import HttpService from '@/shared/services/http-service';

import { IConfig } from '../models/config-viewmodel';
import { Message } from '@/shared/models/view/message-viewmodel';
import { Offering } from '@/shared/models/view/study-viewmodel';

@Component({
    computed: {
        ...mapState(['form', 'config', 'offerings'])
    }
})
export default class OfferingsComponent extends Vue {
    @Prop() studyId!: string;

    @Watch('studyId') 
    onPropertyChanged(value: string, oldValue: string) {
        this.loadData();
    } 

    public config!: IConfig;
    private offerings!: Offering[];

    mounted() {
        this.loadData();
    }

    private loadData() {
        this.$store.commit('setLoading', true);
        Promise.all([
            StudiesService.getOfferingsByStudy(this.config.language, this.studyId, HttpService)
        ])
        .then(values => {
            this.$store.commit('setOfferings', values[0]);
            this.$store.commit('setLoading', false);
        })
        .catch(error => {
            console.log(error)
            this.$store.commit('root/setErrors', [
                this.config.language === 'nl' ? 
                    'Er gaat iets fout, probeer het later nog een keer' : 
                    'Something went wrong, please try again later'
            ]);
            this.$store.commit('setLoading', false);
        })
    }
}
